import { type PersistedClient } from '@tanstack/react-query-persist-client';

const MAX_PERSISTED_QUERY_CACHE_BYTES = 2 * 1024 * 1024;

const getSerializedSize = (value: string): number =>
  new TextEncoder().encode(value).byteLength;

export const serializeQueryCache = (
  persistedClient: PersistedClient,
): string => {
  const clientWithoutQueries: PersistedClient = {
    ...persistedClient,
    clientState: {
      ...persistedClient.clientState,
      queries: [],
    },
  };
  const serializedClientWithoutQueries = JSON.stringify(clientWithoutQueries);
  let serializedSize = getSerializedSize(serializedClientWithoutQueries);
  const queries = [...persistedClient.clientState.queries].sort(
    (a, b) => b.state.dataUpdatedAt - a.state.dataUpdatedAt,
  );
  const persistedQueries: typeof queries = [];

  for (const query of queries) {
    const querySize = getSerializedSize(JSON.stringify(query));
    const separatorSize = persistedQueries.length ? 1 : 0;

    if (
      serializedSize + querySize + separatorSize >
      MAX_PERSISTED_QUERY_CACHE_BYTES
    ) {
      continue;
    }

    persistedQueries.push(query);
    serializedSize += querySize + separatorSize;
  }

  return JSON.stringify({
    ...persistedClient,
    clientState: {
      ...persistedClient.clientState,
      queries: persistedQueries,
    },
  });
};
